<template>
    <div>
        <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline">
            <h4 class="text-capitalize">{{ isProduct ? 'Products' : 'Services'}}</h4>
            <button @click="newProduct"
                    :disabled="loading"
                    class="btn btn-primary">
                New {{ productType }}
            </button>
        </div>
        <AppTable :columns="columns"
                  ref="table"
                  :rows="products"
                  :query="query"
                  @on-row-click="viewProduct"
                  :loading="loading"
                  :total="total"
                  @on-query-change="onQueryChange">
            <template slot="table-row" slot-scope="props">
                <!-- Types -->
                <span v-if="props.column.field === 'types'">
                  <span v-if="props.row.types">
                      <span v-for="type in props.row.types" :key="type.id"
                            class="text-secondary">
                           {{ type.name }}
                      </span>
                  </span>
                </span>
                <!-- Other -->
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
            </template>
        </AppTable>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import AppTable from '../form/AppTable';

export default {
  components: {
    AppTable,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      total: (state) => state.products.total,
    }),
    ...mapGetters({
      products: 'products/products',
    }),
    query() {
      return this.$store.state.products.query[this.productType];
    },
    productType() {
      return this.$route.params.productType;
    },
    isService() {
      return this.productType === 'service';
    },
    isProduct() {
      return this.productType === 'product';
    },
    columns() {
      return [
        {
          label: 'Name',
          field: 'name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Supplier',
          field: 'supplier_company.name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Types',
          field: 'types',
          filterOptions: {
            enabled: true,
          },
        },
      ];
    },
  },
  watch: {
    '$route.params.productType'() {
      this.$refs.table.reset();
      this.getProducts();
    },
  },
  mounted() {
    this.getProducts();
  },
  methods: {
    newProduct() {
      this.$router.push({
        name: 'product',
        params: {
          productType: this.productType,
          id: 'new',
        },
      });
    },
    viewProduct(event) {
      this.$router.push({
        name: 'product',
        params: { productType: this.productType, id: event.row.id },
      });
    },
    getProducts() {
      this.loading = true;
      this.$store.dispatch('products/getProducts', this.productType)
        .finally(() => {
          this.loading = false;
        });
    },
    onQueryChange(props) {
      this.$store.commit('products/queryProps', {
        props,
        categoryType: this.productType,
      });
      this.getProducts();
    },
  },
};
</script>
